export const costs = [
  'Noches en vela buscando cómo traducir conceptos de petróleo y gas complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que el petróleo y gas no tiene nada que ver con ellos ni con su realidad cotidiana.',
  'Silencios incómodos cuando un alumno pregunta sobre geología petrolera o métodos de perforación y no tienes una respuesta clara a mano.',
  'Fines de semana perdidos armando planificaciones, proyectos petroleros y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar fundamentos petroleros, seguridad, ambiente o tecnología sin los recursos adecuados.',
];
